// 繁體中文
export default {
  nav: {
    brandSub: 'AWS 進階合作夥伴',
    links: {
      products: '雲端服務',
      solutions: '解決方案',
      why: '為什麼選擇我們',
      about: '關於我們',
      news: '最新消息'
    },
    cta: '免費諮詢 →',
    ctaMobile: '免費諮詢',
    menu: '選單',
    language: '語言'
  },

  hero: {
    badge: 'AWS 進階合作夥伴 · 已服務 2,000+ 企業',
    titlePre1: '讓雲端',
    titleHi1: '驅動創新',
    titlePre2: '讓業務',
    titleHi2: '通達全球',
    lead: 'Easycloud 身為 AWS 進階合作夥伴，為企業提供高品質、低成本的一站式 AWS 雲端解決方案。從雲端遷移、架構最佳化到託管維運，協助企業擁抱數位轉型，開拓全球市場。',
    ctaPrimary: '免費諮詢方案',
    ctaGhost: '探索服務 ↓',
    stats: [
      { value: '2,000+', label: '服務企業客戶' },
      { value: '5+', label: '全球服務據點' },
      { value: '20+', label: 'AWS 認證專家' }
    ],
    panelTitle: 'AWS Console',
    panelLive: '運行中',
    utilLabel: '全域資源使用率',
    mini: [
      { k: '運行執行個體', v: '3,200+', d: '+12%' },
      { k: '月均節省', v: '38%', d: '成本最佳化' },
      { k: '遷移成功率', v: '99.8%', d: '零中斷' },
      { k: '維運告警', v: '0', d: '穩定' }
    ],
    floatA: { title: 'AWS WAF 架構', sub: 'Well-Architected' },
    floatB: { title: '全球節點', sub: '33 個區域' },
    trust: ['網際網路', '遊戲', '金融科技', '電商零售', 'SaaS', '物聯網 IoT', '社群媒體', '教育科技']
  },

  products: {
    eyebrow: 'Our Services',
    titlePre: '五大核心服務，',
    titleHi: '賦能企業雲端之旅',
    lead: '身為 AWS 進階合作夥伴，Easycloud 提供從雲端遷移、架構最佳化到託管維運的全生命週期服務，協助企業降本增效、加速創新。',
    detailLink: '了解詳情 →',
    items: [
      {
        title: '雲端遷移服務',
        desc: '從評估發現到遷移落地，提供完整的遷移方法論與實施框架，確保業務零中斷平順上雲。',
        features: ['工作負載評估與規劃', '自動化遷移與容器化', '遷移方案驗證與壓力測試']
      },
      {
        title: 'Well-Architected 架構審查',
        desc: '基於 AWS Well-Architected Framework，全面評估現有架構，發現風險並最佳化設計。',
        features: ['六大支柱全面審查', '1:1 架構師指導', '免費架構評估報告']
      },
      {
        title: 'DevOps 服務',
        desc: '基於 AWS 的 CI/CD 與可觀測性方案，自動化部署流程，縮短發佈週期，提升維運效率。',
        features: ['CI/CD 流水線建置', 'Prometheus/Grafana 監控', 'DevOps 文化與培訓']
      },
      {
        title: '託管維運服務 (MSP)',
        desc: '7×24 小時全託管雲端維運，專屬客戶服務團隊，讓您專注於業務創新，維運交給我們。',
        features: ['24/7 監控與告警', '專屬客戶工作小組', '成本最佳化與帳單分析']
      },
      {
        title: '資料與分析服務',
        desc: '基於 AWS 資料湖與分析服務，整合多源資料，實現商業智慧與資料驅動決策。',
        features: ['資料湖建置與整合', 'BI 視覺化報表', '機器學習與 AI 賦能']
      },
      {
        title: '帳戶管理服務',
        desc: 'AWS 帳戶全生命週期管理，包含費用最佳化、產品更新、技術支援與培訓。',
        features: ['用量報告與帳單分析', '預算告警與成本管控', '新產品功能推送']
      }
    ]
  },

  solutions: {
    eyebrow: 'Industry Solutions',
    titlePre: '深耕產業場景的',
    titleHi: 'AWS 雲端解決方案',
    lead: '沉澱多年產業實踐，基於 AWS 全球領先的基礎設施，提供端到端的場景化方案，協助企業降本增效、加速全球化布局。',
    cta: '取得產業方案',
    items: [
      {
        name: '網際網路',
        title: '網際網路雲 · 加速內容分發與全球擴展',
        desc: '為短影音、內容平台等網際網路企業提供 AWS 架構最佳化方案，顯著降低內容載入時間與跨域傳輸成本。',
        points: ['CloudFront CDN 全球加速', 'Auto Scaling 因應流量高峰', 'S3 + CloudFront 低成本儲存分發'],
        metrics: [{ value: '70%', label: '載入時間降低' }, { value: '40%', label: '傳輸成本節省' }]
      },
      {
        name: '遊戲',
        title: '遊戲雲 · 高效能運算與全球部署',
        desc: '基於 AWS 高效能運算資源，為遊戲開發企業提供全球伺服器部署、負載平衡與低延遲體驗。',
        points: ['EC2 高效能執行個體與 GameLift', '跨區域多活部署', '低延遲全球玩家接入'],
        metrics: [{ value: '80%', label: '尖峰故障降低' }, { value: '<50ms', label: '全球延遲' }]
      },
      {
        name: '金融科技',
        title: '金融雲 · 資料驅動的精準決策',
        desc: '藉助 AWS 資料分析服務，為金融科技企業提供使用者輪廓、即時分析與視覺化報表能力。',
        points: ['Redshift/BigQuery 資料分析', '使用者精準輪廓與行為預測', '即時視覺化報表與決策支援'],
        metrics: [{ value: '3x', label: '分析效率提升' }, { value: '99.99%', label: '服務可用性' }]
      },
      {
        name: '物聯網 IoT',
        title: 'IoT 雲 · 安全可靠的萬物互聯',
        desc: '基於 AWS IoT 服務，支援百萬級裝置連線，確保資料安全與裝置可靠性。',
        points: ['AWS IoT Core 海量裝置接入', '即時資料採集與分析', '進階安全協定保護'],
        metrics: [{ value: '百萬級', label: '裝置連線' }, { value: '99.9%', label: '資料可靠性' }]
      },
      {
        name: '電商零售',
        title: '零售雲 · 彈性因應每一次流量高峰',
        desc: '為電商企業提供彈性架構與智慧營運方案，平穩度過大促流量尖峰，提升轉換率。',
        points: ['Auto Scaling 彈性因應大促', '個人化推薦與精準行銷', '全通路會員與交易打通'],
        metrics: [{ value: '3x', label: '大促承載能力' }, { value: '28%', label: '轉換率提升' }]
      }
    ]
  },

  why: {
    eyebrow: 'Why Easycloud',
    titlePre: '企業為什麼選擇',
    titleHi: ' Easycloud',
    lead: '身為 AWS 進階合作夥伴，我們以技術為根基、以服務為承諾，為每一位客戶提供經過驗證的專業技術諮詢與雲端解決方案。',
    features: [
      { icon: '🏅', title: '官方認證合作夥伴', desc: 'AWS 進階諮詢合作夥伴，具備經過驗證的技術實力與豐富的服務經驗。' },
      { icon: '💡', title: '專家指導，而非猜測', desc: '提供經過驗證的專業技術諮詢，讓您的雲端決策準確、安全、與長期目標一致。' },
      { icon: '🔁', title: '端到端價值創造', desc: '從諮詢、架構設計到部署、培訓與託管維運，全程負責，確保轉型產生實際商業價值。' },
      { icon: '💰', title: '節省時間、預算與精力', desc: '避免錯誤技術選型帶來的損失，精簡執行流程，讓您專注於業務擴展。' },
      { icon: '🌏', title: '區域領先，全球標準', desc: '深耕亞太區域，同時具備全球視野，為有全球業務需求的企業提供可靠的雲端服務。' },
      { icon: '🤝', title: '在地化支援', desc: '提供在地語言 L1/L2 支援，更快的故障回應，支援銀行轉帳與合規發票。' }
    ],
    stats: [
      { value: '2,000+', label: '服務企業客戶' },
      { value: '5+', label: '年產業經驗' },
      { value: '5+', label: '全球服務據點' },
      { value: '20+', label: 'AWS 認證專家' }
    ]
  },

  about: {
    eyebrow: 'About Easycloud',
    titleLine1: '賦能企業雲端創新，',
    titleHi: '讓數位轉型更簡單',
    text1: 'Easycloud 成立於 2021 年，身為 AWS 進階合作夥伴，我們從香港、上海、東京、新加坡、杜拜五大策略據點出發，為全球企業提供高品質的 IT 服務現代化解決方案。',
    text2: '我們堅信雲端技術應當簡化業務而非增加複雜性。身為 AWS 託管服務供應商 (MSP)，我們在雲端遷移、架構設計、DevOps、資料分析與託管服務方面設計與營運智慧、低成本的雲端環境，服務於金融、零售、IoT、遊戲、網際網路與社群等產業。',
    pillars: [
      { icon: '🎯', title: '使命', desc: '推進雲端解決方案，協助企業更高效營運、更快創新' },
      { icon: '🌏', title: '願景', desc: '成為企業最信賴的全球 AWS 雲端合作夥伴' },
      { icon: '💎', title: '價值觀', desc: '技術卓越 · 緊密協作 · 結果導向' }
    ],
    certsLabel: '合作夥伴認證',
    certs: ['AWS 進階諮詢合作夥伴', 'AWS MSP 合作夥伴', 'Well-Architected 合作夥伴', 'AWS 認證解決方案架構師'],
    orbitSub: 'AWS Partner'
  },

  partners: {
    label: '已獲得眾多產業領先企業的信賴',
    quote: 'Easycloud 協助我們在三個月內完成核心系統上雲遷移，藉助 AWS Well-Architected Review 最佳化架構，資源成本降低近 40%，系統穩定性與彈性能力都獲得了質的飛躍。他們不僅是雲端服務商，更是值得信賴的技術夥伴。',
    authorName: '林敏',
    authorRole: '某網際網路科技公司 · CTO',
    authorAvatar: '林'
  },

  news: {
    eyebrow: 'News & Insights',
    titlePre: '最新消息與',
    titleHi: '產業洞察',
    more: '檢視全部 →',
    readMore: '閱讀全文 →',
    featured: {
      tag: '活動',
      title: 'AWS re:Invent 2025 圓滿落幕：生成式 AI 與智慧代理成焦點',
      desc: 'AWS 年度旗艦大會再度於拉斯維加斯舉行，主題演講涵蓋 Amazon Bedrock、Amazon Q 與智慧代理 AI，並發佈了面向大規模建構的運算、儲存與資料庫新能力。'
    },
    items: [
      { tag: '生成式 AI', title: 'Amazon Nova：Amazon Bedrock 上的新一代基礎模型' },
      { tag: '資料庫', title: 'Amazon Aurora DSQL：無伺服器分散式 SQL，多活高可用' },
      { tag: '開發者工具', title: 'Amazon Q Developer：貫穿軟體開發全流程的生成式 AI 助手' },
      { tag: '運算', title: 'AWS Graviton4：為 Amazon EC2 帶來更強效能與性價比' }
    ]
  },

  contact: {
    eyebrow: 'Get Started',
    titlePre: '準備好開啟',
    titleHi: ' AWS 雲端之旅',
    titleSuf: '了嗎？',
    lead: '留下您的需求，Easycloud AWS 架構專家將在 1 個工作日內與您聯絡，為您提供專屬上雲方案與報價。',
    info: {
      email: 'hello@easycloud.com',
      address: '香港 · 上海 · 東京 · 新加坡 · 杜拜'
    },
    form: {
      name: '您的稱呼',
      namePlaceholder: '請輸入姓名',
      contact: '聯絡方式',
      contactPlaceholder: '手機號 / 電子郵件',
      company: '企業名稱',
      companyPlaceholder: '選填',
      message: '需求描述',
      messagePlaceholder: '簡單描述您的業務場景或需求'
    },
    submit: '提交諮詢',
    submitted: '✓ 已提交，感謝您！',
    hint: '提交即代表您同意 Easycloud 的隱私政策與服務條款'
  },

  footer: {
    desc: 'AWS 進階合作夥伴，提供雲端遷移、架構最佳化、DevOps 與託管維運的一站式服務。',
    brandSub: 'AWS Partner',
    columns: [
      {
        title: '服務',
        links: [
          { label: '雲端遷移服務', href: '#products' },
          { label: 'Well-Architected 審查', href: '#products' },
          { label: 'DevOps 服務', href: '#products' },
          { label: '託管維運 (MSP)', href: '#products' }
        ]
      },
      {
        title: '解決方案',
        links: [
          { label: '網際網路', href: '#solutions' },
          { label: '遊戲', href: '#solutions' },
          { label: '金融科技', href: '#solutions' },
          { label: '物聯網 IoT', href: '#solutions' }
        ]
      },
      {
        title: '關於',
        links: [
          { label: '公司介紹', href: '#about' },
          { label: '最新消息', href: '#news' },
          { label: '加入我們', href: '#contact' },
          { label: '聯絡我們', href: '#contact' }
        ]
      },
      {
        title: '支援',
        links: [
          { label: '說明文件', href: '#contact' },
          { label: '服務狀態', href: '#contact' },
          { label: '工單系統', href: '#contact' }
        ]
      }
    ],
    copyright: '© 2026 Easycloud. AWS 進階合作夥伴. 保留所有權利.',
    legal: ['隱私政策', '服務條款']
  },

  common: {
    backToTop: '返回頂部'
  }
}
